export default __webpack_public_path__ + "static/media/new_order.df5765de.mp3";